// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"25137cc3","239":"97d52b52","455":"82096e63"}[chunkId] + ".chunk.js";
};